var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiTsCity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,13h2v1h-2v-1Zm4,1h2v-1h-2v1Zm-4,4h2v-1h-2v1Zm4,0h2v-1h-2v1ZM14,6h2v-1h-2v1Zm4,0h2v-1h-2v1Zm-4,4h2v-1h-2v1Zm4,0h2v-1h-2v1Zm6-7.5V24H0V8.329c0-.668,.26-1.296,.732-1.768L3.439,3.854c1.085-1.085,3.036-1.085,4.121,0l2.439,2.439V2.5c0-1.378,1.122-2.5,2.5-2.5h9c1.378,0,2.5,1.122,2.5,2.5Zm-14,5.829c0-.401-.156-.777-.439-1.061l-2.707-2.707c-.713-.713-1.994-.713-2.707,0L1.439,7.268c-.283,.284-.439,.66-.439,1.061v14.671H10V8.329ZM23,2.5c0-.827-.673-1.5-1.5-1.5H12.5c-.827,0-1.5,.673-1.5,1.5V23h12V2.5ZM4,14h3v-1h-3v1Zm0-4h3v-1h-3v1Zm0,8h3v-1h-3v1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiTsCity);
export default __webpack_public_path__ + "static/media/fi-ts-city.f97725ad018969f19661771f12aea07b.svg";
export { ForwardRef as ReactComponent };